import {
  Grid,
  Switch,
  FormControlLabel,
  Typography,
  Button,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  RootState,
  useAppDispatch,
} from "../../../../app/features/store/store";
import {
  CiRatecardValueResponse,
  ClientInvoiceEditDetailResponse,
  ClientInvoiceEditResponse,
  DateRangeInvoiceEditsResponse,
  RatecardClientInvoiceResponse,
  RouteResponse,
  StoreResponseForClientInvoice,
} from "../../../../app/models/responseModels/ClientInvoiceResponses";
import { Field, Form, Formik } from "formik";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import EditRateCard from "./EditRateCard";
import { mapFrequencyNumberToText } from "../../ratecard/utils/RatecardUtils";
import {
  clearCurrentRatecard,
  getRatecardById,
} from "../../../../app/features/ratecard/ratecardSlice";
import { toast } from "react-toastify";
import getAxiosError from "../../../../app/api/axiosError";
import { useSelector } from "react-redux";
import Loader from "../../../../components/common/loader/Loader";
import { EditClientInvoiceUIRequest } from "../ClientInvoiceInterfaces";
import {
  isRouteEdited,
  mapPeakSurchargeToUiRequest,
} from "../utils/ClientInvoiceUtils";
import { getClientInvoiceValidationSchema } from "../ClientInvoiceValidations";
import { EditClientInvoiceRequest, SimpleValueDateRangeTypeForServer } from "../../../../app/models/requestModels/ClientInvoiceEditRequest";
import { ClientInvoiceAgent } from "../../../../app/api/clientInvoices/ClientInvoiceAgent";
import { mapValuesUiRequestToUpdatePeakSurcharge } from "../utils/PeakSurchargeUtils";
import { mapValuesUiRequestToUpdateFuelSurchargeFields } from "../utils/FuelSurchargeUtils";
import {
  getDeletedFieldDateRangeEdits,
  getSimpleFieldDateRangeEdits,
  mapValuesUiRequestToCiRatecard,
} from "../utils/RatecardUtils";
import { CiEditListReponse } from "../../../../app/models/ApiResponse";
import {
  RateCardCustomFieldsResponse,
  RateCardFuelSurchargeFieldsResponse,
  RateCardPeakSurchargeResponse,
  RatecardResponse,
  RatecardValueResponse,
} from "../../ratecard/dtos/RateCardResponse";
import SubmitModalWithFormikAndMultipleDialogActions from "../../../../components/common/modalPopup/SubmitModalWithFormikAndMultipleDialogActions";
import { formatDate } from "../../../../components/common/utils/DateUtils";
import { DateObject } from "react-multi-date-picker";
import agent from "../../../../app/api/agent";
import { StoreFdpsResponse } from "../../../../app/models/responseModels/FdpResponse";
import LateCancelsAndAdjustments from "./LateCancelAndAdjustments";
import { CLIENT_INVOICE_STATUS } from "../ClientInvoiceConstants";
import CustomFields from "../../ratecard/routeRate/CustomFields";

interface EditInvoiceDetailsProps {
  clientId: number;
  invoice: RatecardClientInvoiceResponse | undefined;
  onCompleted(): unknown;
  store: string;
  startDate: string | null;
  endDate: string | null;
  route: RouteResponse | null;
  ratecardId: number;
  currentEditId: number | null;
  closeEditInvoiceDetailsModal: CallableFunction;
  onAddNewStores: CallableFunction;
  isFdpInvoiceEdit: boolean;
  fdpInvoiceId: number | null;
  fdpInvoiceStatus: string | null;
}

const EditInvoiceDetailsModal = (props: EditInvoiceDetailsProps) => {
  const dispatch = useAppDispatch();

  const [selectedStores, setSelectedStores] = useState<
    StoreResponseForClientInvoice[]
  >([]);

  const getStoreNamesFromStoreIds = (ids: number[]) => {
    let result = "";
    ids.forEach((id, index) => {
      const storeName = props.invoice?.stores.find(
        (store) => store.id === id
      )?.storeId;
      result += storeName;
      if (index < ids.length - 1) result += ",";
    });
    return result;
  };

  const prepareSelectedStoresList = () => {
    const selectedStorePkIds = props.store.split(",").map(Number);
    const allSelectedStores: StoreResponseForClientInvoice[] = [];
    selectedStorePkIds.forEach((id) => {
      const store = props.invoice?.stores.find((store) => store.id === id);
      if (store) {
        allSelectedStores.push(store);
      }
    });
    setSelectedStores(allSelectedStores);
  };

  const checkShowDiscount = (
    ratecardValues: RatecardValueResponse | CiRatecardValueResponse | undefined
  ) => {
    if (ratecardValuesData?.discountType !== undefined) return true;
    return false;
  };

  const checkShowRoute = (forSwitch: boolean) => {
    if (forSwitch) {
      //       for switch

      // NO EDIT SELECTED BUTTON

      // if props.route = yes => route in edit data or not(doesn't matter) => yes => YES
      // if props.route = no => route WILL NOT BE in edit data =>  NO

      if (!props.currentEditId) {
        if (props.route) return true;
        else return false;
      }

      // EDIT SELECTED BUTTON

      //       if props.route = yes
      // 	=> route in edit data or not(doesn't matter) => yes => YES
      // if props.route = no
      // 	=> but route in edit data => yes =>  YES (override)
      else {
        if (props.route) return true;
        else {
          if (editData?.editRoute) return true;
          else return false;
        }
      }
    } else {
      //       for actually show the fields

      // NO EDIT SELECTED BUTTON

      // if props.route = yes => route in edit data => no => NO
      // if props.route = no => route WILL NOT BE in edit data =>  NO

      if (!props.currentEditId) {
        if (props.route) {
          if (editData?.editRoute) return true;
          else return false;
        } else return false;
      }

      // EDIT SELECTED BUTTON

      // if route in edit data = yes => YES
      // if route in edit data = no => NO
      if (editData?.editRoute) return true;
      else return false;
    }
  };

  const [isDataFetching, setDataFetching] = useState(true);
  const [editList, setEditList] = useState<ClientInvoiceEditResponse[]>([]);
  const [dateRangeEditList, setDateRangeEditList] = useState<
    DateRangeInvoiceEditsResponse | undefined
  >(undefined);

  const [deleteEditIdList, setDeleteEditIdList] = useState<number[]>([]);

  const [editData, setEditData] =
    useState<ClientInvoiceEditDetailResponse | null>(null);

  const [originalRatecard, setOriginalRatecard] = useState<
    RatecardResponse | undefined
  >(undefined);

  const [ratecardValuesData, setRatecardValuesData] = useState<
    RatecardValueResponse | undefined
  >(undefined);

  const [ ratecardCustomFieldsData, setRateCardCustomFieldsData ] = useState<RateCardCustomFieldsResponse[]>([]);

  const [fuelSurchargeFields, setFuelSurchargeFields] = useState<
    RateCardFuelSurchargeFieldsResponse[]
  >([]);

  const [peakSurcharges, setPeakSurcharges] = useState<
    RateCardPeakSurchargeResponse[]
  >([]);

  const [isAddMoreStores, setIsAddMoreStores] = useState<boolean>(false);
  const [isEditSubmitted, setIsEditSubmitted] = useState<boolean>(false);
  const [associatedFdpsToStore, setAssociatedFdpsToStore] = useState<
    StoreFdpsResponse[]
  >([]);

  const { authResponse } = useSelector((state: RootState) => state.login);

  useEffect(() => {
    // if (props.invoice && props.invoice.invoiceStatus === "generated")
    //   getRatecardByIdData();
    // else {
    //   // fetch the edited ratecard from the ratecard_client_invoice_edit table
    //   getEditData();
    //   // fetchEditList();
    //   fetchDateRangeEdits();
    // }

    if (props.invoice) {
      getRatecardByIdData();
      // fetch the edited ratecard from the ratecard_client_invoice_edit table
      if (props.currentEditId) getEditData(true);
      else getEditData();
      fetchDateRangeEdits();
      prepareSelectedStoresList();
    }
    return () => {
      dispatch(clearCurrentRatecard());
    };
  }, []);

  const getLinkedFdpsForStore = useCallback(async () => {
    try {
      const selectedStoreIds = props.store.split(",").map(Number);
      const response = await agent.FdpAgent.getFdpListByStore(selectedStoreIds);
      if (response.isSuccess) {
        setAssociatedFdpsToStore(response.data);
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "FdpsForStoresException",
      });
    }
  }, [props.store]);

  useEffect(() => {
    getLinkedFdpsForStore();
  }, [getLinkedFdpsForStore]);

  // get ratecard by id data
  const getRatecardByIdData = async () => {
    if (props.ratecardId) {
      try {
        const response = await dispatch(
          getRatecardById(props.ratecardId)
        ).unwrap();
        if (!response.isSuccess) {
          console.error(
            `error - response.isSuccess is false - ${JSON.stringify(response)}`
          );
          toast.error(response.message, {
            toastId: "getRatecardById",
          });
          return;
        } else {
          setOriginalRatecard(response.data);
          setRatecardValuesData(response.data.ratecardValues);

          if(response.data.rateCardCustomFieldsData)
            setRateCardCustomFieldsData(response.data.rateCardCustomFieldsData);

          if (response.data.ratecardFuelSurchargeFields)
            setFuelSurchargeFields(response.data.ratecardFuelSurchargeFields);
          if (response.data.ratecardPeakSurcharges)
            setPeakSurcharges(response.data.ratecardPeakSurcharges);
        }
      } catch (error) {
        const appError = getAxiosError(error);
        console.error(`error - ${JSON.stringify(error)}`);
        toast.error(appError.errorMessage, {
          toastId: "getRatecardByIdException",
        });
      } finally {
        setDataFetching(false);
      }
    }
  };

  const { isLoading: isCurrentRatecardLoading, currentRatecard } = useSelector(
    (state: RootState) => state.ratecard
  );

  const getEditData = async (getSingle = false) => {
    if (props.ratecardId && props.invoice?.clientInvoiceId) {
      try {
        // console.log(`inside getEditData`);
        let response = null;
        if (getSingle && props.currentEditId)
          response = await ClientInvoiceAgent.getEditDataById(
            props.currentEditId
          );
        else
          response = await ClientInvoiceAgent.getEditData(
            props.invoice?.clientInvoiceId,
            props.store,
            props.startDate,
            props.endDate,
            props.route?.tripId ?? null,
            props.ratecardId ?? null
          );

        if (response.data) {
         

          setEditData(response.data);
          // console.log(`inside getEditData fetch complete before if`);
          // if (
          //   !response.data ||
          //   !response.data.ratecardValues ||
          //   !response.data.ratecardValues.baseRate
          // ) {
          //   // console.log(`edit ratecard data is null`);
          //   getRatecardByIdData();
          // } else {
          // console.log(`edit ratecard data is NOT null`);

          if (response.data.ratecardValues) {
            let editValues: RatecardValueResponse | undefined =
              ratecardValuesData;
            if (editValues === undefined)
              editValues = response.data.ratecardValues;
            else {
              if (response.data.ratecardValues.baseRate) {
                console.log(
                  `edit baseRate = ${response.data.ratecardValues.baseRate}`
                );
                editValues.baseRate = response.data.ratecardValues.baseRate;
              }
              if (response.data.ratecardValues.variableRate) {
                editValues.variableRate =
                  response.data.ratecardValues.variableRate;
                editValues.variableRateType =
                  response.data.ratecardValues.variableRateType;
              }
              if (response.data.ratecardValues.routeMinimum)
                editValues.routeMinimum =
                  response.data.ratecardValues.routeMinimum;
              if (response.data.ratecardValues.lateCancellationCharge) {
                editValues.lateCancellationCharge =
                  response.data.ratecardValues.lateCancellationCharge;
                editValues.lateCancellationType =
                  response.data.ratecardValues.lateCancellationType;
              }
            }
            setRatecardValuesData(editValues);
          }
          if (
            response.data.ratecardFuelSurchargeFields &&
            response.data.ratecardFuelSurchargeFields.length > 0
          )
            setFuelSurchargeFields(response.data.ratecardFuelSurchargeFields);
          if (
            response.data.ratecardPeakSurcharges &&
            response.data.ratecardPeakSurcharges.length > 0
          )
            setPeakSurcharges(response.data.ratecardPeakSurcharges);
          // }
        }

        if (!response.isSuccess) {
          console.log(
            `error - response.isSuccess is false - ${JSON.stringify(response)}`
          );
          toast.error(response.message, {
            toastId: "getEditDataById",
          });
          return;
        }
      } catch (error) {
        const appError = getAxiosError(error);
        console.log(`error - ${JSON.stringify(error)}`);
        toast.error(appError.errorMessage, {
          toastId: "getRatecardByIdException",
        });
      } finally {
        setDataFetching(false);
      }
    }
  };

  const fetchDateRangeEdits = async () => {
    if (props.invoice?.clientInvoiceId) {
      try {
        const response = await ClientInvoiceAgent.getDateRangeEdits(
          props.invoice?.clientInvoiceId,
          props.store
        );
        if (!response.isSuccess) {
          console.log(
            `error - response.isSuccess is false - ${JSON.stringify(response)}`
          );
          toast.error(response.message, {
            toastId: "getDateRangeEdits",
          });
          return;
        } else {
          setDateRangeEditList(response.data);
          const dateRangeEdits: DateRangeInvoiceEditsResponse = response.data;
        }
      } catch (error) {
        const appError = getAxiosError(error);
        console.log(`error - ${JSON.stringify(error)}`);
        toast.error(appError.errorMessage, {
          toastId: "getDateRangeEditsException",
        });
      } finally {
        setDataFetching(false);
      }
    }
  };

  console.log(props.invoice?.startDateRange +": "+ props.invoice?.endDateRange);

  const initialValues: EditClientInvoiceUIRequest = {
    show_route: checkShowRoute(false),
    totalOrders:
      (editData?.editRoute && editData?.editRoute.totalOrders) ??
      props.route?.totalOrders,
    ordersDelivered:
      (editData?.editRoute && editData?.editRoute.ordersDelivered) ??
      props.route?.ordersDelivered,
    ordersUndelivered:
      (editData?.editRoute && editData?.editRoute.ordersUndelivered) ??
      props.route?.ordersUndelivered,
    ordersUndeliveredNoAttempt:
      (editData?.editRoute && editData?.editRoute.ordersUndeliveredNoAttempt) ??
      props.route?.ordersUndeliveredNoAttempt,
    totalLateCancellation: editData?.totalLateCancellation,
    onetimeAdjustmentValue: editData?.onetimeAdjustmentValue,
    onetimeAdjustmentDescription: editData?.onetimeAdjustmentDescription,
    show_ratecard:
      editData?.ratecardValues.baseRate !== undefined || !props.route
        ? true
        : false,
    // RATECARD DATA
    // VALUES
    // rateCardCustomFieldsData: editData?.ratecardCustomFieldsDto ?? [],
    // show_custom_fields:editData?.ratecardCustomFieldsDto ? true : false,
    // master_date_range:
    //   props.currentEditId && props.route
    //     ? []
    //     : props.invoice
    //     ? [
    //         new DateObject().parse(props.invoice?.startDateRange),
    //         new DateObject().parse(props.invoice?.endDateRange),
    //       ]
    //     : [],

    master_date_range: props.invoice?.startDateRange && props.invoice?.endDateRange
  ? [
      new Date(props.invoice.startDateRange),
      new Date(props.invoice.endDateRange),
    ]
  : [],
    values_id: ratecardValuesData?.id ?? undefined,
    baseRate: props.route
      ? editData?.ratecardValues.baseRate ??
        originalRatecard?.ratecardValues.baseRate
      : originalRatecard?.ratecardValues.baseRate,
    base_rate_date_range: [],
    base_rate_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.fieldEdits &&
      dateRangeEditList.fieldEdits.length > 0
        ? dateRangeEditList.fieldEdits.filter(
            (fieldEdit) => fieldEdit.fieldName === "baseRate"
          )
        : [],
    variableRate: props.route
      ? editData?.ratecardValues.variableRate ??
        originalRatecard?.ratecardValues.variableRate
      : originalRatecard?.ratecardValues.variableRate,
    variable_rate_date_range: [],
    variable_rate_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.fieldEdits &&
      dateRangeEditList.fieldEdits.length > 0
        ? dateRangeEditList.fieldEdits.filter(
            (fieldEdit) => fieldEdit.fieldName === "variableRate"
          )
        : [],
    routeMinimum: props.route
      ? editData?.ratecardValues.routeMinimum ??
        originalRatecard?.ratecardValues.routeMinimum
      : originalRatecard?.ratecardValues.routeMinimum,
    route_minimum_date_range: [],
    route_minimum_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.fieldEdits &&
      dateRangeEditList.fieldEdits.length > 0
        ? dateRangeEditList.fieldEdits.filter(
            (fieldEdit) => fieldEdit.fieldName === "routeMinimum"
          )
        : [],
    lateCancellationCharge: props.route
      ? editData?.ratecardValues.lateCancellationCharge ??
        originalRatecard?.ratecardValues.lateCancellationCharge
      : originalRatecard?.ratecardValues.lateCancellationCharge,
    late_cancellation_date_range: [],
    late_cancellation_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.fieldEdits &&
      dateRangeEditList.fieldEdits.length > 0
        ? dateRangeEditList.fieldEdits.filter(
            (fieldEdit) => fieldEdit.fieldName === "lateCancellationCharge"
          )
        : [],
    variableRateType: `${
      props.route
        ? editData?.ratecardValues.variableRateType ??
          originalRatecard?.ratecardValues.variableRateType
        : originalRatecard?.ratecardValues.variableRateType
    }`,
    lateCancellationType: `${
      props.route
        ? editData?.ratecardValues.lateCancellationType ??
          originalRatecard?.ratecardValues.lateCancellationType
        : originalRatecard?.ratecardValues.lateCancellationType
    }`,
    fuelType: ratecardValuesData?.fuelType ?? "",
    regionName: ratecardValuesData?.regionName ?? "",
    discountType:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? originalRatecard?.ratecardValues.discountType
          : undefined
        : checkShowDiscount(editData?.ratecardValues)
        ? editData?.ratecardValues.discountType
        : undefined,
    discountMinVolumeRate:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? originalRatecard?.ratecardValues.discountMinVolumeRate
          : undefined
        : checkShowDiscount(editData?.ratecardValues)
        ? editData?.ratecardValues.discountMinVolumeRate
        : undefined,
    discountFrequency:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? mapFrequencyNumberToText(
              originalRatecard?.ratecardValues.discountFrequency ?? undefined
            )
          : ""
        : checkShowDiscount(editData?.ratecardValues)
        ? mapFrequencyNumberToText(
            editData?.ratecardValues.discountFrequency ?? undefined
          )
        : "",
    discountUnitType:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? originalRatecard?.ratecardValues.discountUnitType
          : undefined
        : checkShowDiscount(editData?.ratecardValues)
        ? editData?.ratecardValues.discountUnitType
        : undefined,
    discountValue:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? originalRatecard?.ratecardValues.discountValue
          : undefined
        : checkShowDiscount(editData?.ratecardValues)
        ? editData?.ratecardValues.discountValue
        : undefined,
    // discount - UI parameters
    show_discount:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? true
          : false
        : checkShowDiscount(editData?.ratecardValues)
        ? true
        : false,
    discount_type:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues)
          ? originalRatecard?.ratecardValues.discountType === "volume"
            ? "volume"
            : "rate"
          : "volume"
        : checkShowDiscount(editData?.ratecardValues)
        ? editData?.ratecardValues.discountType === "volume"
          ? "volume"
          : "rate"
        : "volume",
    // discount - UI parameters - volume
    discount_custom_value: editData?.discountCustomValue,
    discount_volume_min_unit:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType === "volume"
          ? originalRatecard?.ratecardValues.discountMinVolumeRate
          : undefined
        : editData?.ratecardValues.discountType === "volume"
        ? editData?.ratecardValues.discountMinVolumeRate
        : undefined,
    discount_volume_frequency:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues) &&
          originalRatecard?.ratecardValues.discountType === "volume"
          ? mapFrequencyNumberToText(ratecardValuesData?.discountFrequency)
          : ""
        : checkShowDiscount(editData?.ratecardValues) &&
          editData?.ratecardValues.discountType === "volume"
        ? mapFrequencyNumberToText(ratecardValuesData?.discountFrequency)
        : "",
    discount_volume_unit_type:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType === "volume"
          ? originalRatecard?.ratecardValues.discountUnitType
          : null
        : editData?.ratecardValues.discountType === "volume"
        ? editData?.ratecardValues.discountUnitType
        : null,
    discount_volume_value_percentage:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType === "volume" &&
          originalRatecard?.ratecardValues.discountUnitType === "percentage"
          ? originalRatecard?.ratecardValues.discountValue
          : undefined
        : editData?.ratecardValues.discountType === "volume" &&
          editData?.ratecardValues.discountUnitType === "percentage"
        ? editData?.ratecardValues.discountValue
        : undefined,
    discount_volume_value_dollar:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType === "volume" &&
          originalRatecard?.ratecardValues.discountUnitType === "value"
          ? originalRatecard?.ratecardValues.discountValue
          : undefined
        : editData?.ratecardValues.discountType === "volume" &&
          editData?.ratecardValues.discountUnitType === "value"
        ? editData?.ratecardValues.discountValue
        : undefined,
    // discount - UI parameters - rate
    discount_rate_type:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues) &&
          originalRatecard?.ratecardValues.discountType !== "volume"
          ? originalRatecard?.ratecardValues.discountType
          : undefined
        : checkShowDiscount(editData?.ratecardValues) &&
          editData?.ratecardValues.discountType !== "volume"
        ? originalRatecard?.ratecardValues.discountType
        : undefined,
    discount_rate_frequency:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          checkShowDiscount(originalRatecard?.ratecardValues) &&
          originalRatecard?.ratecardValues.discountType !== "volume"
          ? mapFrequencyNumberToText(
              originalRatecard?.ratecardValues.discountFrequency
            )
          : ""
        : checkShowDiscount(editData?.ratecardValues) &&
          editData?.ratecardValues.discountType !== "volume"
        ? mapFrequencyNumberToText(editData?.ratecardValues.discountFrequency)
        : "",
    discount_rate_min_unit:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType !== "volume"
          ? originalRatecard?.ratecardValues.discountMinVolumeRate
          : undefined
        : editData?.ratecardValues.discountType !== "volume"
        ? editData?.ratecardValues.discountMinVolumeRate
        : undefined,
    discount_rate_unit_type:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType !== "volume"
          ? originalRatecard?.ratecardValues.discountUnitType ?? null
          : null
        : editData?.ratecardValues.discountType !== "volume"
        ? editData?.ratecardValues.discountUnitType ?? null
        : null,
    discount_rate_value_percentage:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType !== "volume" &&
          originalRatecard?.ratecardValues.discountUnitType === "percentage"
          ? originalRatecard?.ratecardValues.discountValue
          : undefined
        : editData?.ratecardValues.discountType !== "volume" &&
          editData?.ratecardValues.discountUnitType === "percentage"
        ? editData?.ratecardValues.discountValue
        : undefined,
    discount_rate_value_dollar:
      props.route === null
        ? // if route then prefill with edited data
          // no route then prefill with original ratecard data
          originalRatecard?.ratecardValues.discountType !== "volume" &&
          originalRatecard?.ratecardValues.discountUnitType === "value"
          ? originalRatecard?.ratecardValues.discountValue
          : undefined
        : editData?.ratecardValues.discountType !== "volume" &&
          editData?.ratecardValues.discountUnitType === "value"
        ? editData?.ratecardValues.discountValue
        : undefined,
    discount_date_range: [],
    discount_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.discountDateRangeEdits &&
      dateRangeEditList.discountDateRangeEdits.length > 0
        ? dateRangeEditList.discountDateRangeEdits
        : [],

    // FUEL SURCHARGE
    show_fuel_surcharge:
      (fuelSurchargeFields && fuelSurchargeFields.length > 0) ||
      editData?.fuelCustomValue
        ? true
        : false,

    fuel_surcharge_date_range: [],
    fuel_surcharge_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.fuelSurchargeDateRangeEdits &&
      dateRangeEditList.fuelSurchargeDateRangeEdits.length > 0
        ? dateRangeEditList.fuelSurchargeDateRangeEdits
        : [],
    fuel_surcharge_custom_value: editData?.fuelCustomValue,
    fuelSurchargeFields:
      props.route === null
        ? 
          originalRatecard?.ratecardFuelSurchargeFields ?? []
        : editData?.ratecardFuelSurchargeFields &&
          editData?.ratecardFuelSurchargeFields.length > 0
        ? editData?.ratecardFuelSurchargeFields
        : 
          originalRatecard?.ratecardFuelSurchargeFields ?? [],
    fuelSurchargeLookup: currentRatecard?.ratecardFuelSurchargeLookup ?? [],
    show_custom_fields:
    (CustomFields && CustomFields.length > 0) 
   // || editData?.fuelCustomValue
      ? true
      : false,
      ratecardCustomFieldsData: 
      editData?.ratecardCustomFieldsDto && editData.ratecardCustomFieldsDto.length > 0 
      ? editData.ratecardCustomFieldsDto 
      : 
      originalRatecard?.rateCardCustomFieldsData ?? [],
      custom_fields_date_range: [],
      custom_fields_date_range_values:
        dateRangeEditList &&
        dateRangeEditList.customFieldsDateRangeEdits &&
        dateRangeEditList.customFieldsDateRangeEdits.length > 0
          ? dateRangeEditList.customFieldsDateRangeEdits
          : [],

    lookup_file_upload: false,
    // // PEAK SURCHCARGE
    show_peak_surcharge:
    (originalRatecard?.ratecardPeakSurcharges && originalRatecard?.ratecardPeakSurcharges.length > 0) ||
    (editData?.ratecardPeakSurcharges && editData?.ratecardPeakSurcharges.length > 0) ||
  
    editData?.peakCustomValue
      ? true
      : false,
    peak_surcharge_custom_value: editData?.peakCustomValue,
    peakSurcharge: mapPeakSurchargeToUiRequest(
      editData?.ratecardPeakSurcharges ??
      originalRatecard?.ratecardPeakSurcharges ??
      []
    ),
    
      
     peak_surcharge_date_range: [],
    peak_surcharge_date_range_values:
      dateRangeEditList &&
      dateRangeEditList.peakSurchargeDateRangeEdits &&
      dateRangeEditList.peakSurchargeDateRangeEdits.length > 0
        ? dateRangeEditList.peakSurchargeDateRangeEdits
        : [],
  };

  console.log("Edit Data", editData);
  const handleSubmit = async (
    uiRequest: EditClientInvoiceUIRequest,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    try {
      console.log(`inside handleSubmit`);
      console.log(`uiRequest = ${JSON.stringify(uiRequest)}`);
      if (props.invoice && props.invoice.id) {
        console.log(`inside outer if`);
        const serverRequest: EditClientInvoiceRequest = {
          clientId: props.clientId,
          storeIds: props.store.split(",").map(Number),
          isFdpInvoiceEdit: props.isFdpInvoiceEdit,
        };
        if (props.isFdpInvoiceEdit) {
          // status change for fdp invoice
          if (isEditSubmitted) {
            serverRequest.invoiceStatus = "ops_edited";
          } else if (props.fdpInvoiceStatus === "fin_flagged") {
            // if fdp invoice is fin flagged then change status to draft for the first time edit
            serverRequest.invoiceStatus = "draft";
          }
        } else {
          // status change for client invoice
          if (isEditSubmitted) {
            console.log(`isEditSubmitted  = ${isEditSubmitted}`);
            // if user is ops then ops_edited
            serverRequest.invoiceStatus = CLIENT_INVOICE_STATUS.OPS_EDITED;
          } else if (
            props.invoice.invoiceStatus === CLIENT_INVOICE_STATUS.GENERATED ||
            props.invoice.invoiceStatus === CLIENT_INVOICE_STATUS.OPS_REVIEW
          ) {
            // if generated or ops_review then change status to draft for edit
            serverRequest.invoiceStatus = CLIENT_INVOICE_STATUS.DRAFT;
          }
        }
        // if (props.startDate && props.endDate) {
        //   console.log(`startdate and end date`);
        //   serverRequest.startDate = props.startDate;
        //   serverRequest.endDate = props.endDate;
        // }

        if (
          uiRequest.master_date_range &&
          uiRequest.master_date_range.length === 2
        ) {
          console.log(`master date range`);
          serverRequest.startDate = formatDate(
            uiRequest.master_date_range[0]
          );
          serverRequest.endDate = formatDate(
            uiRequest.master_date_range[1]
          );
        }

        console.log(`before edit data`);

        // add clientInvoiceEditId so that for subsequent edits the same edit will be edited
        if (editData) serverRequest.clientInvoiceEditId = editData.id;

        console.log(`before show route`);

        if (props.route) {
          console.log(`add trip id`);

          // add trip id for ratecard not caring if route is edited or not
          // as only ratecard can also be edited when route is selected
          serverRequest.tripId = props.route.tripId;
        }
        if (uiRequest.show_route && props.route) {
          console.log(`add route`);

          // check if route data is changed or not
          console.log(
            `Yes routes = ${JSON.stringify(
              uiRequest.totalOrders !== undefined &&
                uiRequest.ordersDelivered !== undefined &&
                uiRequest.ordersUndelivered !== undefined &&
                uiRequest.ordersUndeliveredNoAttempt !== undefined
            )}`
          );

          console.log(
            `is route edited = ${isRouteEdited(
              uiRequest,
              props.route,
              editData?.editRoute
            )}`
          );

          if (
            // below checks that the fields are not undefined
            uiRequest.totalOrders !== undefined &&
            uiRequest.ordersDelivered !== undefined &&
            uiRequest.ordersUndelivered !== undefined &&
            uiRequest.ordersUndeliveredNoAttempt !== undefined &&
            isRouteEdited(uiRequest, props.route, editData?.editRoute)
          ) {
            console.log(`Yes routes after`);
            // add route server request
            serverRequest.route = {
              routeId: props.route.id,
              totalOrders: uiRequest.totalOrders,
              ordersDelivered: uiRequest.ordersDelivered,
              ordersUndelivered: uiRequest.ordersUndelivered,
              ordersUndeliveredNoAttempt: uiRequest.ordersUndeliveredNoAttempt,
            };
          }
        }
        console.log(`show ratecard`);

        if (uiRequest.show_ratecard && originalRatecard) {
          console.log(`add ratecard`);

          // add ratecard server request
          // const updateRateCardValues = mapValuesUiRequestToUpdateRatecardValue(
          //   addRatecardValuesUIRequest
          // );

          const ciFuelSurchargeFields =
            mapValuesUiRequestToUpdateFuelSurchargeFields(
              uiRequest,
              authResponse?.userSettings?.userName,
              props.invoice.invoiceStatus
            );

          const updateRateCardFuelSurchargeLookup =
            uiRequest.lookup_file_upload &&
            uiRequest.fuelSurchargeLookup.length > 0
              ? uiRequest.fuelSurchargeLookup
              : [];

          const ciPeakSurcharges = mapValuesUiRequestToUpdatePeakSurcharge(
            uiRequest,
            props.invoice.invoiceStatus
          );

          

          const ciCustomFields = uiRequest.ratecardCustomFieldsData.map(field => ({
            ratecardCustomFieldName: field.ratecardCustomFieldName,
            ratecardCustomFieldAmount: field.ratecardCustomFieldAmount,
            ratecardCustemFieldPerPackage: field.ratecardCustemFieldPerPackage,
            ratecardCustomFieldApplicableFor: field.ratecardCustomFieldApplicableFor,
           // customFieldDate: field.customFieldDate,
          }));

          if (ratecardValuesData)
            serverRequest.ratecard = mapValuesUiRequestToCiRatecard(
              originalRatecard.ratecardId,
              uiRequest,
              ratecardValuesData,
              ciFuelSurchargeFields,
              updateRateCardFuelSurchargeLookup,
              ciCustomFields,
              ciPeakSurcharges
            );

          // serverRequest.ratecard = mapValuesUiRequestToCiRatecard(
          //   uiRequest,
          //   ciFuelSurchargeFields,
          //   updateRateCardFuelSurchargeLookup,
          //   ciPeakSurcharges
          // );
        }

        console.log(`total Late Cancellationss`);
        // add total late cancellation and one-time adjustments
        if (uiRequest.totalLateCancellation)
          serverRequest.totalLateCancellation = uiRequest.totalLateCancellation;
        if (uiRequest.onetimeAdjustmentValue) {
          serverRequest.onetimeAdjustmentValue =
            uiRequest.onetimeAdjustmentValue;
          serverRequest.onetimeAdjustmentDescription =
            uiRequest.onetimeAdjustmentDescription;
        }

        // add delete edit list
        // if (deleteEditIdList.length > 0)
        //   serverRequest.deleteEditIdList = deleteEditIdList;

        console.log(`Before send final request`);
        if (!props.route) {
          // if no route then check for field level date range edits
          // and deletion of existing field level date range edits
          const uiFieldEdits = getSimpleFieldDateRangeEdits(uiRequest);
          const serverFieldEdits: SimpleValueDateRangeTypeForServer[] = uiFieldEdits.map((uiFieldEdit) => {
            const serverFieldEdit: SimpleValueDateRangeTypeForServer = {
              id: uiFieldEdit.id,
              storeIds: uiFieldEdit.storeIds,
              editStatus: uiFieldEdit.editStatus,
              startDate: formatDate(uiFieldEdit.startDate),
              endDate: formatDate(uiFieldEdit.endDate),
              fieldName: uiFieldEdit.fieldName,
              fieldValue: uiFieldEdit.fieldValue,
              fieldType: uiFieldEdit.fieldType,
            };
            return serverFieldEdit;
          });
          serverRequest.fieldEdits = serverFieldEdits;
          serverRequest.discountDateRangeEdits =
            uiRequest.discount_date_range_values;
          serverRequest.fuelSurchargeDateRangeEdits =
            uiRequest.fuel_surcharge_date_range_values;
          serverRequest.deleteFieldEditList = getDeletedFieldDateRangeEdits(
            uiFieldEdits,
            dateRangeEditList?.fieldEdits ?? [],
            // discount
            serverRequest.discountDateRangeEdits,
            dateRangeEditList?.discountDateRangeEdits ?? [],
            // fuel surcharge
            serverRequest.fuelSurchargeDateRangeEdits,
            dateRangeEditList?.fuelSurchargeDateRangeEdits ?? []
          );
          if (uiRequest?.master_date_range?.length < 2) {
            serverRequest.ratecard = undefined;
          }
        }
        serverRequest.isFdpInvoiceEdit = props.isFdpInvoiceEdit;
        serverRequest.fdpInvoiceId = props.fdpInvoiceId ?? null;
        console.log(`send final request`);
        console.log(`${JSON.stringify(serverRequest)}`);

        const response: CiEditListReponse =
          await ClientInvoiceAgent.editClientInvoice(
            props.invoice.id,
            serverRequest
          );
        if (!response.isSuccess) {
          console.log(
            `error - response.isSuccess is false - ${JSON.stringify(response)}`
          );
          toast.error(response.message, {
            toastId: "editClientInvoice",
          });
        } else {
          toast.success(
            `${
              props.isFdpInvoiceEdit ? "FDP" : "Client"
            } Invoice has been edited successfully.`
          );
          setEditList(response.data);
        }
      }
    } catch (error) {
      const appError = getAxiosError(error);
      console.log(`error - ${JSON.stringify(error)}`);
      if (appError.code === "400") {
        toast.error("Some error occured", {
          toastId: "editClientInvoiceException",
        });
      } else {
        toast.error(appError.errorMessage, {
          toastId: "editClientInvoiceException",
        });
      }
    } finally {
      console.log(`finally`);
      setSubmitting(false);

      if (isEditSubmitted) props.onCompleted();
      else {
        // earlier we have add more stores button
        // but now the save progress will so same work as add more stores as we will move to InvoiceEditModal on save progress button click
        // so using the same logic as add more stores here
        // will rename and remove add new stores when this finalizes
        props.onAddNewStores();
      }

      // if (isAddMoreStores) props.onAddNewStores();
      // else props.onCompleted();
    }
    return true;
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={getClientInvoiceValidationSchema()}
        onSubmit={(values: EditClientInvoiceUIRequest, { setSubmitting }) => {
          setSubmitting(true);
          handleSubmit(values, setSubmitting);
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          isSubmitting,
          submitForm,
          isValid,
          touched,
          errors,
        }) => {

          console.log("Values in Edit Invoice Details Modal", values);
          console.log("start type:", typeof values.master_date_range?.[0]);
          console.log("Start Date is ", values.master_date_range?.[0]);
          
          console.log("is start DateObject:", values.master_date_range?.[0] instanceof Function);

          console.log("value type check", values.master_date_range?.map(v => ({
  hasToDate: typeof v === "function",
  isDate: v instanceof Date,
})));
          //console.log(`errors - ${JSON.stringify(errors)}`);

          //console.log(`values = ${JSON.stringify(values)}`);
          // console.log(
          //   `ratecardValuesData = ${JSON.stringify(ratecardValuesData)}`
          // );

          console.log(`props.invoice = ${JSON.stringify(props.invoice)}`);
          console.log(`props.ratecardId = ${props.ratecardId}`);
          console.log(
            `originalRatecard === undefined = ${originalRatecard === undefined}`
          );
          console.log(`isCurrentRatecardLoading = ${isCurrentRatecardLoading}`);
          console.log(`isSubmitting = ${isSubmitting}`);
          console.log(`isDataFetching = ${isDataFetching}`);
          return (
            <SubmitModalWithFormikAndMultipleDialogActions
              title="Edit Invoice Details"
              closeSubmitModal={props.closeEditInvoiceDetailsModal}
              childErrorMessage={""}
              allowSubmit={false}
              size="lg" 
              isLoading={false}
              submitButtonName="Save Progress"
              closeModalAfterSubmit={false}
              allowSubmitWithoutTouch={true}
              fullWidth={true}
              dialogActionChildrenBefore={
                <>
                  {/* <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      // SAVE PROGRESS ON ADD MORE STORES
                      setIsAddMoreStores(true);
                      submitForm();
                    }}
                  >
                    Add more Stores
                  </Button> */}
                </>
              }
              dialogActionChildrenAfter={
                <>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={
                      // Object.keys(touched).length === 0 ||
                      !isValid
                    }
                    onClick={() => {
                      setIsEditSubmitted(true);
                      submitForm();
                    }}
                  >
                    Submit
                  </Button>
                </>
              }
            >
              <Loader
                isLoading={
                  originalRatecard === undefined ||
                  isCurrentRatecardLoading ||
                  isSubmitting ||
                  isDataFetching
                }
              />
              <Form>
                <Grid container alignItems={"center"}>
                  <Grid item container>
                    Invoice Date Range: {props.invoice?.startDateRange} to{" "}
                    {props.invoice?.endDateRange}
                  </Grid>
                  <Grid item container>
                    Stores:{" "}
                    {getStoreNamesFromStoreIds(
                      props.store.split(",").map(Number)
                    )}
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      id="show_route"
                      name="show_route"
                      label="Edit Route"
                      sx={{
                        ml: 0,
                        mr: 2,
                        display:
                          // !props.route && !editData?.editRoute ? "none" : "",
                          checkShowRoute(true) ? "" : "none",
                      }}
                      labelPlacement="start"
                      checked={values.show_route}
                      control={
                        <Field
                          id="show_route"
                          name="show_route"
                          component={Switch}
                          type="checkbox"
                          size="small"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      }
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="overline">
                      {editData?.editRoute?.tripId ?? props.route?.tripId}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={2}
                  alignItems={"center"}
                  display={values.show_route ? "" : "none"}
                >
                  <Grid item xs={6}>
                    <FormikTextField
                      name="totalOrders"
                      margin="normal"
                      label="Total Orders"
                      size="small"
                      fullWidth
                      variant={"outlined"}
                      helperText={
                        editData &&
                        editData.editRoute &&
                        props.route?.totalOrders !==
                          editData?.editRoute.totalOrders
                          ? `Original value : ${props.route?.totalOrders}`
                          : ""
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      name="ordersDelivered"
                      margin="normal"
                      label="Orders Delivered"
                      size="small"
                      fullWidth
                      variant={"outlined"}
                      helperText={
                        editData &&
                        editData.editRoute &&
                        props.route?.ordersDelivered !==
                          editData?.editRoute.ordersDelivered
                          ? `Original value : ${props.route?.ordersDelivered}`
                          : ""
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      name="ordersUndelivered"
                      margin="normal"
                      label="Orders Undelivered"
                      size="small"
                      fullWidth
                      variant={"outlined"}
                      helperText={
                        editData &&
                        editData.editRoute &&
                        props.route?.ordersUndelivered !==
                          editData?.editRoute.ordersUndelivered
                          ? `Original value : ${props.route?.ordersUndelivered}`
                          : ""
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      name="ordersUndeliveredNoAttempt"
                      margin="normal"
                      label="Orders Undelivered No Attempt"
                      size="small"
                      fullWidth
                      variant={"outlined"}
                      helperText={
                        editData &&
                        editData.editRoute &&
                        props.route?.ordersUndeliveredNoAttempt !==
                          editData?.editRoute.ordersUndeliveredNoAttempt
                          ? `Original value : ${props.route?.ordersUndeliveredNoAttempt}`
                          : ""
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <hr />
                  </Grid>
                </Grid>
                <FormControlLabel
                  id="show_ratecard"
                  name="show_ratecard"
                  label="Edit Ratecard"
                  sx={{
                    mt: 2,
                    ml: 0,
                    display: props.route ? "" : "none",
                  }}
                  labelPlacement="start"
                  checked={values.show_ratecard}
                  control={
                    <Field
                      id="show_ratecard"
                      name="show_ratecard"
                      component={Switch}
                      type="checkbox"
                      size="small"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  }
                />

                <Grid
                  item
                  xs={12}
                  display={
                    !props.route || (props.route && values.show_ratecard)
                      ? ""
                      : "none"
                  }
                >
                  <EditRateCard
                    // originalRatecardData={currentRatecard?.ratecardValues}
                    originalRatecardData={originalRatecard}
                    values={values}
                    touched={touched}
                    route={props.route}
                    store={props.store}
                    invoiceStartDate={
                      new Date(props.invoice?.startDateRange ?? "")
                    }
                    invoiceEndDate={new Date(props.invoice?.endDateRange ?? "")}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    editData={editData}
                  />
                </Grid>
                <Grid item xs={12} mt={2} mb={2}>
                  <hr />
                </Grid>
              </Form>
              <LateCancelsAndAdjustments
                invoice={props.invoice}
                associatedStoreFdps={associatedFdpsToStore}
                selectedStores={selectedStores}
              />
            </SubmitModalWithFormikAndMultipleDialogActions>
          );
        }}
      </Formik>
    </>
  );
};

export default EditInvoiceDetailsModal;
